import PartnerService from '../../services/PartnerService';
import toast from 'react-hot-toast';

export const PARTNERS_LOADING = '[Partners] Loading';
export const GET_PARTNERS_SUCCESS = '[Partners] Get Partners Success';
export const GET_PARTNERS_FAILED = '[Partners] Get Partners Failed';
export const GET_PARTNER_BY_ID_SUCCESS = '[Partners] Get Partner By ID Success';
export const CREATE_PARTNER_SUCCESS = '[Partners] Create Partner Success';
export const CREATE_PARTNER_FAILED = '[Partners] Create Partner Failed';
export const UPDATE_PARTNER_SUCCESS = '[Partners] Update Partner Success';
export const UPDATE_PARTNER_FAILED = '[Partners] Update Partner Failed';
export const DELETE_PARTNER_SUCCESS = '[Partners] Delete Partner Success';
export const GET_PARTNER_DROPDOWN_SUCCESS = '[Partners] Get Partner Dropdown Success';

export function partnersLoading(status) {
  return { type: PARTNERS_LOADING, payload: status };
}

export function getPartnersAction(params = {}) {
  return async (dispatch) => {
    dispatch(partnersLoading(true));
    try {
      const response = await PartnerService.listPartners(params);
      dispatch({ type: GET_PARTNERS_SUCCESS, payload: response });
    } catch (error) {
      dispatch({ type: GET_PARTNERS_FAILED, payload: error.message || 'Failed to fetch partners' });
    } finally {
      dispatch(partnersLoading(false));
    }
  };
}

export function getPartnerByIdAction(id) {
  return async (dispatch) => {
    dispatch(partnersLoading(true));
    try {
      const response = await PartnerService.getPartnerById(id);
      dispatch({ type: GET_PARTNER_BY_ID_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: GET_PARTNERS_FAILED, payload: error.message || 'Failed to fetch partner' });
    } finally {
      dispatch(partnersLoading(false));
    }
  };
}

export function createPartnerAction(partnerData, callback) {
  return async (dispatch) => {
    dispatch(partnersLoading(true));
    try {
      const response = await PartnerService.createPartner(partnerData);
      if (response.success) {
        dispatch({ type: CREATE_PARTNER_SUCCESS, payload: response.data });
        toast.success(response.message || 'Partner created');
        if (callback) callback(null, response.data, true);
      } else {
        dispatch({ type: CREATE_PARTNER_FAILED, payload: response.message });
        if (callback) callback({ message: response.message }, null, false);
      }
    } catch (error) {
      dispatch({ type: CREATE_PARTNER_FAILED, payload: error.message || 'Failed to create partner' });
      if (callback) callback({ message: error.message }, null, false);
    } finally {
      dispatch(partnersLoading(false));
    }
  };
}

export function updatePartnerAction(id, partnerData, callback) {
  return async (dispatch) => {
    dispatch(partnersLoading(true));
    try {
      const response = await PartnerService.updatePartner(id, partnerData);
      if (response.success) {
        dispatch({ type: UPDATE_PARTNER_SUCCESS, payload: response.data });
        toast.success(response.message || 'Partner updated');
        if (callback) callback(null, response.data, true);
      } else {
        dispatch({ type: UPDATE_PARTNER_FAILED, payload: response.message });
        if (callback) callback({ message: response.message }, null, false);
      }
    } catch (error) {
      dispatch({ type: UPDATE_PARTNER_FAILED, payload: error.message || 'Failed to update partner' });
      if (callback) callback({ message: error.message }, null, false);
    } finally {
      dispatch(partnersLoading(false));
    }
  };
}

export function deletePartnerAction(id, scope = {}, callback) {
  return async (dispatch) => {
    dispatch(partnersLoading(true));
    try {
      const response = await PartnerService.deletePartner(id, scope);
      if (response.success) {
        dispatch({ type: DELETE_PARTNER_SUCCESS, payload: response.data });
        toast.success(response.message || 'Partner deleted');
        if (callback) callback(null, response.data, true);
      } else {
        if (callback) callback({ message: response.message || 'Failed to delete' }, null, false);
      }
    } catch (error) {
      if (callback) callback({ message: error.message }, null, false);
    } finally {
      dispatch(partnersLoading(false));
    }
  };
}

export function getPartnerDropdownAction(companyId, branchId) {
  return async (dispatch) => {
    try {
      const response = await PartnerService.getPartnerDropdown(companyId, branchId);
      if (response.success) {
        dispatch({ type: GET_PARTNER_DROPDOWN_SUCCESS, payload: response.data });
      }
      return response;
    } catch (error) {
      return { success: false, message: error.message };
    }
  };
}
